import moment from 'moment'

const DAYS_REAPPEAR = 7
const MIN_MINUTES_INSTALLED = 10
const CHANCE = 0.1 // 10%

export default class NpsUtils {
  static getReappearMoment() {
    return moment.parseZone().add(DAYS_REAPPEAR, 'days')
  }

  static shouldRender(pathname, user, dismissed, score, showAfter) {
    const dismissedUntilReappear = dismissed && showAfter && (moment.parseZone() < showAfter)
    if (!this.shouldShowOnPath(pathname) || !user || dismissedUntilReappear || score != null) return false

    const earliestTimeToRender = moment
      .parseZone(user.timePeriodStartedAt)
      .add(MIN_MINUTES_INSTALLED, 'minutes')

    if (earliestTimeToRender > moment.parseZone()) return false
    if (Math.random() > CHANCE) return false

    return true
  }

  static shouldShowOnPath(pathname) {
    pathname = pathname.replace(/^\//, "")

    return pathname.match(/^(checks\/seoproblems|checks\/speed|checks\/blog|plus\/manage\/)/)
  }
}



// WEBPACK FOOTER //
// ./app/utils/NpsUtils.js